import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=b5723e30"
import script from "./ColumnChart.vue?vue&type=script&lang=ts"
export * from "./ColumnChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports